import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import AlbaranPdfButton from "./AlbaranPdfButton";
import QRCode from "react-qr-code";
import "../components/QR.css";
import https from "../pluggins/http";
import { getAlbaran } from "../pluggins/albaranes";
import { useConnectionStatus } from "../hooks/useConnectionStatus";

function QR({ location }) {
  const [albaran, setAlbaran] = useState(null);
  const isOnline = useConnectionStatus();
  // Lista ya cargada previamente y persistida (redux-persist) para poder
  // seguir mostrando el QR sin conexión ("cobertura").
  const albaranesCache = useSelector((state) => state?.app?.albaranes || []);

  useEffect(() => {
    const buscarEnCache = () => {
      const encontrado = albaranesCache.find(
        (a) => String(a?.id) === String(location.id)
      );
      if (encontrado) {
        setAlbaran(encontrado);
      }
    };

    const fetchAlbaran = async () => {
      if (!isOnline) {
        buscarEnCache();
        return;
      }
      try {
        const response = await getAlbaran(location.id);
        setAlbaran(response.data);
      } catch (error) {
        console.log("Error fetching albaran:", error);
        buscarEnCache();
      }
    };

    fetchAlbaran();
  }, [location.id, isOnline, albaranesCache]);

  const markAlbaran = async () => {
    try {
      const response = await https.post("updateAlbaran", {
        id: albaran.id,
        estado: "scanned",
      });
      if (response.data?.data) {
        alert("El albarán se actualizó correctamente.");
      }
    } catch {}
  };

  const generateQRContent = () => {
    if (!albaran) return "";
    // Soporta tanto la forma "ver_obra"/"verts"/"residuo" (respuesta directa de la API)
    // como "verObra" (forma usada en la lista cacheada por redux-persist).
    const obra = albaran?.ver_obra || albaran?.verObra;
    const destino = albaran?.verts;
    const residuo = albaran?.residuo;
    const qrPayload = {
      id: albaran?.id,
      ref: albaran.ref,
      operador_id: obra?.op?.id,
      conductor_id: albaran?.conductor_id,
      obra_id: obra?.id,
      destino_id: destino?.id,
      tipo_residuo_id: residuo?.id,
      codigo_LER: albaran?.codigo_LER,
      m3_Kg: albaran?.m3_Kg,
      camion: albaran?.camion,
      fecha: albaran?.fecha,
    };
    return qrPayload;
  };

  return (
    <div id="containerPrincipalQR">
      <div id="containerPopupQR">
        <p className="textQR">
          Tu Codigo QR ha sido {<br />} creado correctamente
        </p>
        <div className="containerTxt">
          <div className="containerQR">
            <span>
              <strong>Id: {albaran?.ref}</strong>
            </span>
          </div>
            <QRCode value={JSON.stringify(generateQRContent())} size={300} level="L" />
        </div>
        <div>
          <Link to={"/ListScreen"}>
            <button className="filterBTnQR">Volver</button>
          </Link>
          <button
            type="submit"
            onClick={markAlbaran}
            className="waitMarkButton"
          >
            Marcar "en espera"
          </button>
        </div>
      </div>
    </div>
  );
}

export default QR;
